<template>
  <!-- 兼容旧 CMS/活动「素材库」按钮：底层改为租户统一素材库（infra_file） -->
  <TenantMaterialSelector
    v-model="dialogVisible"
    :default-module="defaultModule"
    :file-size-mb="10"
    :media-type="mediaType || 'IMAGE'"
    :multiple="multiple"
    @confirm="onConfirm"
  />
</template>

<script lang="ts" setup>
import TenantMaterialSelector from '@/components/TenantMaterialSelector/index.vue'
import type { FileVO } from '@/api/infra/file'
import type { MediaVO } from '@/api/cms/media'

defineOptions({ name: 'MediaSelector' })

interface Props {
  modelValue: boolean
  mediaType?: 'IMAGE' | 'VIDEO' | 'FILE' | ''
  multiple?: boolean
  /** 默认业务模块，CMS/活动页默认 cms */
  defaultModule?: string
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: false,
  mediaType: '',
  multiple: false,
  defaultModule: 'cms'
})

const emit = defineEmits<{
  (e: 'update:modelValue', val: boolean): void
  (e: 'confirm', items: MediaVO[]): void
}>()

const dialogVisible = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val)
})

const toMediaType = (type?: string): MediaVO['mediaType'] => {
  if ((type || '').startsWith('image/')) return 'IMAGE'
  if ((type || '').startsWith('video/')) return 'VIDEO'
  return 'FILE'
}

const onConfirm = (items: FileVO[]) => {
  // 保持旧 MediaVO 形状，调用方仍用 items[0].url
  const mapped: MediaVO[] = items.map((f) => ({
    id: f.id,
    title: f.name,
    url: f.url,
    mediaType: toMediaType(f.type),
    fileSize: f.size,
    mimeType: f.type
  }))
  emit('confirm', mapped)
}
</script>
